const getTimestamp = (document = {}) => {
  const timestamp = new Date(document.updatedAt || document.createdAt || 0).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const getUploadedDocument = (documents = [], requirement = {}) => {
  const requirementTypeId = requirement.requirementId || requirement.id;
  const matchingDocuments = documents.filter((document) => {
    const sameType = Number(document.documentTypeId) === Number(requirementTypeId) ||
      document.documentType === requirement.document_type;
    const sameSubject = (document.subjectType || 'company') === (requirement.subjectType || 'company');
    const sameIndex = Number(document.subjectIndex || 1) === Number(requirement.subjectIndex || 1);
    const sameSide = (document.documentSide || 'single') === (requirement.documentSide || 'single');
    return sameType && sameSubject && sameIndex && sameSide;
  });

  return matchingDocuments.sort((left, right) => {
    const timeDifference = getTimestamp(right) - getTimestamp(left);
    if (timeDifference !== 0) return timeDifference;
    return Number(right.id || 0) - Number(left.id || 0);
  })[0] || null;
};

export const hasAcceptedUpload = (documents, requirement) => {
  const document = getUploadedDocument(documents, requirement);
  return Boolean(document && document.verificationStatus !== 'rejected');
};
